(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-width-product-description"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-description-accordion')) {
    customElements.define(
      'product-description-accordion',
      class ProductDescriptionAccordion extends HTMLElement {
        connectedCallback() {
          this.details = this.querySelector('details');
          this.summary = this.querySelector('summary');
          this.panel = this.querySelector('.full-width-product-description__panel');
          this.mobileQuery = window.matchMedia('(max-width: 767px)');
          this.defaultOpen = this.dataset.defaultOpen === 'true';

          if (!this.details || !this.summary || !this.panel) return;

          this.summary.addEventListener('click', (event) => this.toggle(event));
          this.mobileQuery.addEventListener('change', () => this.reset(true));
          this.reset(true);
        }

        toggle(event) {
          if (!this.mobileQuery.matches || this.dataset.mobileAccordion !== 'true') return;

          event.preventDefault();

          if (this.details.open) {
            this.panel.style.height = `${this.panel.scrollHeight}px`;
            requestAnimationFrame(() => {
              this.panel.style.height = '0px';
            });
            this.panel.addEventListener(
              'transitionend',
              () => {
                this.details.open = false;
                this.panel.style.height = '';
              },
              { once: true }
            );
          } else {
            this.details.open = true;
            this.panel.style.height = '0px';
            requestAnimationFrame(() => {
              this.panel.style.height = `${this.panel.scrollHeight}px`;
            });
            this.panel.addEventListener(
              'transitionend',
              () => {
                this.panel.style.height = 'auto';
              },
              { once: true }
            );
          }
        }

        reset(applyDefaultState = false) {
          this.panel.style.height = '';

          if (!this.mobileQuery.matches || this.dataset.mobileAccordion !== 'true') {
            this.details.open = true;
            return;
          }

          if (applyDefaultState) {
            this.details.open = this.defaultOpen;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drg-partner-reviews')) {
    customElements.define('drg-partner-reviews', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true, signal: this.controller.signal });
        } else {
          this.setup();
        }
      }

      disconnectedCallback() {
        this.controller.abort();
        clearTimeout(this.searchTimer);
      }

      setup() {
        this.list = this.querySelector('[data-list]');
        if (!this.list) return;
        this.cards = Array.from(this.list.querySelectorAll('[data-review-id]')).map((node) => ({
          node,
          text: node.textContent.normalize('NFKC').toLocaleLowerCase(),
          rating: node.dataset.rating,
          date: Number(node.dataset.published)
        })).sort((a, b) => b.date - a.date);
        this.search = this.querySelector('[data-search]');
        this.rating = this.querySelector('[data-rating-filter]');
        this.sort = this.querySelector('[data-sort]');
        this.pageSelect = this.querySelector('[data-page]');
        this.status = this.querySelector('[data-status]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.size = Math.max(1, Number(this.dataset.pageSize) || 6);
        const options = { signal: this.controller.signal };
        this.search.addEventListener('input', () => {
          clearTimeout(this.searchTimer);
          this.searchTimer = setTimeout(() => this.filter(), 150);
        }, options);
        this.rating.addEventListener('change', () => this.filter(), options);
        this.sort.addEventListener('change', () => this.filter(), options);
        this.querySelector('[data-reset]').addEventListener('click', () => {
          clearTimeout(this.searchTimer);
          this.search.value = '';
          this.rating.value = 'all';
          this.sort.value = 'newest';
          this.filter();
          this.search.focus();
        }, options);
        this.prev.addEventListener('click', () => this.go(this.page - 1), options);
        this.next.addEventListener('click', () => this.go(this.page + 1), options);
        this.pageSelect.addEventListener('change', () => this.go(Number(this.pageSelect.value)), options);
        this.querySelector('[data-tools]').hidden = false;
        this.status.hidden = false;
        this.setAttribute('data-enhanced', '');
        this.querySelector('[data-viewport]').removeAttribute('tabindex');
        this.filter();
      }

      filter() {
        const words = this.search.value.normalize('NFKC').toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
        this.filtered = this.cards.filter((card) =>
          (this.rating.value === 'all' || card.rating === this.rating.value) && words.every((word) => card.text.includes(word))
        );
        if (this.sort.value === 'oldest') this.filtered.reverse();
        this.page = 1;
        this.pages = Math.max(1, Math.ceil(this.filtered.length / this.size));
        this.pageSelect.replaceChildren();
        const fragment = document.createDocumentFragment();
        for (let page = 1; page <= this.pages; page++) {
          const label = this.dataset.pageTemplate.replace('__current__', page).replace('__total__', this.pages);
          fragment.append(new Option(label, page));
        }
        this.pageSelect.append(fragment);
        this.draw();
      }

      go(page) {
        this.page = Math.max(1, Math.min(this.pages, page));
        this.draw();
        this.status.setAttribute('tabindex', '-1');
        this.status.focus({ preventScroll: true });
        this.status.scrollIntoView({ block: 'start', behavior: 'instant' });
      }

      draw() {
        this.cards.forEach(({ node }) => { node.hidden = true; });
        const start = (this.page - 1) * this.size;
        this.filtered.slice(start, start + this.size).forEach(({ node }) => {
          this.list.append(node);
          node.hidden = false;
        });
        this.status.textContent = this.dataset.statusTemplate
          .replace('__start__', this.filtered.length ? start + 1 : 0)
          .replace('__end__', Math.min(start + this.size, this.filtered.length))
          .replace('__count__', this.filtered.length.toLocaleString(document.documentElement.lang || 'en'));
        this.pageSelect.value = String(this.page);
        this.prev.disabled = this.page === 1;
        this.next.disabled = this.page === this.pages;
        this.querySelector('[data-empty]').hidden = this.filtered.length > 0;
        this.querySelector('[data-pagination]').hidden = this.pages <= 1;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
  const initializeHalloweenCountdowns = (root = document) => {
    root.querySelectorAll('[data-halloween-countdown]').forEach((countdown) => {
      if (countdown.dataset.initialized === 'true') return;

      const deadline = Date.parse(countdown.dataset.deadline);
      if (Number.isNaN(deadline)) return;

      countdown.dataset.initialized = 'true';
      const units = countdown.querySelector('[data-countdown-units]');
      const ended = countdown.querySelector('[data-countdown-ended]');
      const days = countdown.querySelector('[data-countdown-days]');
      const hours = countdown.querySelector('[data-countdown-hours]');
      const minutes = countdown.querySelector('[data-countdown-minutes]');
      const seconds = countdown.querySelector('[data-countdown-seconds]');
      let interval;

      const update = () => {
        const remaining = Math.max(0, deadline - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);

        days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
        hours.textContent = String(Math.floor((totalSeconds % 86400) / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        seconds.textContent = String(totalSeconds % 60).padStart(2, '0');

        if (remaining === 0) {
          units.hidden = true;
          ended.hidden = false;
          window.clearInterval(interval);
        }
      };

      update();
      if (deadline > Date.now()) {
        interval = window.setInterval(update, 1000);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHalloweenCountdowns());
  } else {
    initializeHalloweenCountdowns();
  }

  document.addEventListener('shopify:section:load', (event) => initializeHalloweenCountdowns(event.target));

  } catch(e) { console.error(e); }
})();
})();
